import classNames from 'classnames';
import { type TaskCTABlockProps } from './TaskCTABlock.types';
import TaskCTA from './TaskCTA';

const TaskCTABlock: React.FC<TaskCTABlockProps> = ({
  showTitle,
  title,
  content,
  items,
  limit,
}) => (
  <>
    {(items || content) && (
      <div className="task-cta-block">
        {(showTitle || content) && (
          <div className="task-cta-block__main">
            {showTitle && (
              <h2 className="task-cta-block__heading h3">{title}</h2>
            )}
            {content && (
              <div
                className="task-cta-block__content"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            )}
          </div>
        )}
        {items.length > 0 && (
          <div
            className={classNames(
              'task-ctas',
              limit === 3 && 'task-ctas--three-columns',
            )}
          >
            {items.map((item, index) => (
              <TaskCTA key={index} {...item} />
            ))}
          </div>
        )}
      </div>
    )}
  </>
);
export default TaskCTABlock;
